import { expVal } from '@confluence/feature-experiments';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';
import { isRovoSystemSpaceKey } from '@confluence/route-manager/entry-points/isRovoSystemSpaceKey.ts';

type IsSmartSpaceOverviewEnabledParams = {
	spaceKey: string;
	isRovoEnabled: boolean;
	cloudId?: string | null;
};

export const isSmartSpaceOverviewEnabled = ({
	spaceKey,
	isRovoEnabled,
	cloudId,
}: IsSmartSpaceOverviewEnabledParams) =>
	Boolean(cloudId) &&
	!isCompanyHubSpaceKey(spaceKey) &&
	!isRovoSystemSpaceKey(spaceKey) &&
	isRovoEnabled &&
	expVal('smart_space_overview', 'isEnabled', false);
